/** Rule-based clinical assist suggestions */

const RULES = [
  { keys: ['fever', 'cough', 'cold', 'throat'], dx: ['URTI', 'Viral fever'], labs: ['CBC', 'CRP'], rx: ['Paracetamol 650mg', 'Levocetirizine 5mg'] },
  { keys: ['chest pain', 'breathless', 'dyspnea'], dx: ['Acute bronchitis', 'Rule out ACS'], labs: ['ECG', 'Chest X-Ray', 'Troponin'], rx: [] },
  { keys: ['abdominal', 'gastric', 'acidity', 'burning'], dx: ['Acute gastritis', 'GERD'], labs: ['USG Abdomen'], rx: ['Pantoprazole 40mg', 'Sucralfate 1g'] },
  { keys: ['diabetes', 'sugar', 'polyuria'], dx: ['Type 2 DM — review'], labs: ['FBS', 'PPBS', 'HbA1c'], rx: ['Metformin 500mg'] },
  { keys: ['hypertension', 'bp high', 'headache'], dx: ['Hypertension'], labs: ['Renal function', 'Lipid profile'], rx: ['Amlodipine 5mg'] },
  { keys: ['rash', 'itch', 'allergy'], dx: ['Allergic dermatitis'], labs: [], rx: ['Levocetirizine 5mg', 'Calamine lotion'] },
  { keys: ['uti', 'burning urine', 'dysuria'], dx: ['UTI'], labs: ['Urine routine', 'Urine culture'], rx: ['Nitrofurantoin 100mg'] },
  { keys: ['child', 'pediatric', 'infant'], dx: ['Pediatric illness — assess hydration'], labs: [], rx: ['Paracetamol (weight-based dose)'] },
];

export function docAssistSuggestions(complaint = '', age = '') {
  const text = `${complaint} ${age}`.toLowerCase();
  const hits = RULES.filter((r) => r.keys.some((k) => text.includes(k)));
  if (!hits.length) {
    return {
      diagnosis: ['Clinical evaluation needed'],
      labs: ['CBC if indicated'],
      rx: [],
      advice: ['Adequate rest and fluids', 'Return if symptoms worsen'],
    };
  }
  const dx = [...new Set(hits.flatMap((h) => h.dx))];
  const labs = [...new Set(hits.flatMap((h) => h.labs))];
  const rx = [...new Set(hits.flatMap((h) => h.rx))];
  return { diagnosis: dx, labs, rx, advice: ['Follow up in 3–5 days if no improvement'] };
}
